"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioCovenantResultIterable = void 0;
exports.PortfolioCovenantResultIterable = [
    'PASS',
    'FAIL',
    'LEVEL_1_FAIL',
    'LEVEL_2_FAIL',
    'LEVEL_3_FAIL',
    'LEVEL_4_FAIL',
    'LEVEL_5_FAIL',
    'LEVEL_6_FAIL',
    'LEVEL_7_FAIL',
    'LEVEL_8_FAIL',
    'LEVEL_9_FAIL',
    'LEVEL_10_FAIL',
];
//# sourceMappingURL=PortfolioCovenant.js.map